import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import api from '../api';
import { LoadingText } from '../components/Style';
import CreateList from './CreateList';
import Post from '../types/Post';

// Route glue for editing an existing list.
//
// CreateList already implements edit mode end to end: given an `editPost` prop
// it seeds title, kind, order style, caption and items, skips the draft
// restore, and saves with PATCH /api/lists/:id instead of POST. What it never
// had was a caller. ListDetailView linked to /list/edit?listId=..., a route
// that did not exist on the source branch, so the button was dead. This
// supplies the missing half: fetch the post, hand it over.
//
// Deliberately loads with full item inclusion via the post detail endpoint,
// since feed responses only carry a 4-item preview and editing needs all of
// them.
function EditList() {
  var [searchParams] = useSearchParams();
  var listId = searchParams.get('listId');

  var _post = useState<Post | null>(null);
  var post = _post[0];
  var setPost = _post[1];

  var _error = useState('');
  var error = _error[0];
  var setError = _error[1];

  useEffect(
    function () {
      if (!listId) {
        setError('No list specified.');
        return;
      }
      var cancelled = false;
      api
        .get('/api/posts/id/' + listId)
        .then(function (res) {
          if (cancelled) return;
          if (!res.data || res.data.kind !== 'list') {
            setError('That post is not a list.');
            return;
          }
          setPost(res.data);
        })
        .catch(function (e) {
          if (cancelled) return;
          // The detail endpoint 404s an unpublished list for anyone but its
          // author, so this covers both "gone" and "not yours".
          setError(
            e.response && e.response.status === 404
              ? 'That list does not exist, or is not yours to edit.'
              : 'Could not load that list. Please try again.'
          );
        });
      return function () {
        cancelled = true;
      };
    },
    [listId]
  );

  if (error) {
    return <LoadingText style={{ color: 'tomato' }}>{error}</LoadingText>;
  }
  if (!post) {
    return <LoadingText>Loading list...</LoadingText>;
  }
  return <CreateList editPost={post} />;
}

export default EditList;
